import { produce } from 'immer';
import { atomWithReducer } from 'jotai/utils';
import type { LightReminder, Reminder } from 'modules/Reminders/api';
import { isNonNullish } from 'remeda';

export type ResendReminderModalState = {
  reminder: LightReminder | Reminder | null;
  modalStep: 'preview' | 'input' | 'confirmIgnore';
  canIgnore: boolean;
};

type ResendReminderModalAction =
  | { type: 'open'; reminder: LightReminder | Reminder; canIgnore?: boolean }
  | { type: 'close' }
  | { type: 'ignore'; reminder?: LightReminder | Reminder }
  | { type: 'confirmPreview' };

const reminderModalInitialState: ResendReminderModalState = {
  reminder: null,
  modalStep: 'preview',
  canIgnore: true,
};

function reminderModalReducer(
  prev: ResendReminderModalState,
  action: ResendReminderModalAction,
): ResendReminderModalState {
  return produce(prev, draft => {
    switch (action.type) {
      case 'open':
        draft.reminder = action.reminder;
        draft.modalStep = 'preview';
        draft.canIgnore = action.canIgnore ?? true;
        break;
      case 'close':
        Object.assign(draft, reminderModalInitialState);
        break;
      case 'ignore':
        if (isNonNullish(action.reminder)) draft.reminder = action.reminder;
        draft.modalStep = 'confirmIgnore';
        break;
      case 'confirmPreview':
        draft.modalStep = 'input';
        break;
      default:
        break;
    }
  });
}

export const resendReminderModalAtom = atomWithReducer<
  ResendReminderModalState,
  ResendReminderModalAction
>(reminderModalInitialState, reminderModalReducer);
